import Vue from 'vue';
import Vuex from 'vuex';
import { state, actions, mutations, getters } from 'ant-design-vue-admin-x';
import Common from '@/utils/common';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ...state,
    dateDetail: {},
    forecast: [],
    nowWeather: {},
    time: '',
    activeIndex: '',
    isOptData: '',
    apkAccept: '.apk,.ipa', // apk格式
    excelAccept: '.xls,.xlsx', // excel格式
    uploadUrl: '/file/gov_upload',
    imgAccept: 'image/jpg,image/png,image/bmp,image/gif,image/jpeg', // 图片格式

    feedBackStatusSelect: [
      { label: '已回复', value: 1 },
      { label: '未回复', value: 0 }
    ],
    sendStatusList: [
      { label: '已发送', value: 1 },
      { label: '未发送', value: 0 }
    ],
    pushStatusList: [
      { label: '已推送', value: 1 },
      { label: '未推送', value: 0 },
      { label: '被撤回', value: 3 }
    ],
    statusList: [
      { label: '正常', value: 1 },
      { label: '禁用', value: 0 }
    ],
    isSuccessList: [
      { label: '成功', value: 1 },
      { label: '失败', value: 0 }
    ],
    isExpireList: [
      { label: '未过期', value: 1 },
      { label: '已过期', value: 0 }
    ],
    booleanList: [
      { label: '是', value: 1 },
      { label: '否', value: 0 }
    ],
    isOnLineList: [
      { label: '在线', value: 1 },
      { label: '离线', value: 0 }
    ],
    isBandList: [
      { label: '绑定', value: 1 },
      { label: '未绑定', value: 0 }
    ],
    makeCardList: [
      { label: '普通', value: 0 },
      { label: '加密', value: 1 }
    ],
    sexList: [
      { label: '保密', value: 0 },
      { label: '男', value: 1 },
      { label: '女', value: 2 }
    ],
    readStatusList: [
      { label: '已读', value: 1 },
      { label: '未读', value: 0 }
    ],
    userRange: [
      { label: '全部用户', value: 0 },
      { label: '指定城市', value: 1 },
      { label: '指定小区', value: 2 }
      // { label: '指定用户', value: 3 }
    ],
    platformList: [
      { label: 'Android', value: 1 },
      { label: 'iOS', value: 2 }
    ],
    modalDetailConfig: { // modal详情配置
      footer: null,
      closable: false,
      maskClosable: true,
      keyboard: true,
      destroyOnClose: true,
      centered: true,
      width: 800
    },
    modalConfig: {// modal配置
      maskClosable: false,
      keyboard: false,
      destroyOnClose: true,
      centered: true,
      width: 900
    },
    base_itemLayout: {
      labelCol: { span: 8 },
      wrapperCol: { span: 9 }
    },
    long_itemLayout: {
      labelCol: {span: 5},
      wrapperCol: {span: 13}
    },
    modal_ItemLayout: {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 }
    },
    step_ItemLayout: {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 }
    },
    advanced_colWidth: { md: 8, sm: 24 },
    advanced_col_12: { md: 12, sm: 24 },
    componentArr: [
      'govRole',
      'govAccount',
      'remindWarn',
      'blackListRecord',
      'blackList',
      'monitor',
      'over',
      'manage',
      'viewsIndex'
    ]
  },
  mutations: {
    ...mutations,
    setActiveIndex (state, param) {
      state.activeIndex = param;
    },

    setDateDetail (state, params) {
      state.dateDetail = params;
    },
    setForecast (state, params) {
      state.forecast = params;
    },
    setNowWeather (state, params) {
      state.nowWeather = params;
    },
    setTime (state, params) {
      state.time = params;
    }
  },
  actions: {
    ...actions
  },
  getters: { ...getters },
  modules: {
  }
});
